export enum StoreStatus {
  Idle = 'idle',
  Loading = 'loading',
  Loaded = 'loaded',
  Creating = 'creating',
  Updating = 'updating',
  Deleting = 'deleting',
  Success = 'success',
  Error = 'error',
}
